if (window.location.href.indexOf("/loyalty") !== -1) {
var urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.has('email')) {
        var email = urlParams.get('email');      
        $("#email").val(email);
    } else {
        console.log('Email parameter not found in the URL.');
    }
}